<template>
  <v-app>
    <Loading />
    <CookieConsent />
    <SnackBar />
    <v-app-bar small clipped-left dense app fixed color="white">
      <v-app-bar-nav-icon @click="drawer=!drawer"></v-app-bar-nav-icon>
      <router-link :to="{name: 'home', params:{ locale: $i18n.locale}}">
        <v-img src="/logo.png" max-height="180px" max-width="180px"></v-img>
      </router-link>
      <v-toolbar-title
        class="font-weight-black body-2"
        v-if="$vuetify.breakpoint.mdAndUp"
      >{{ $t("catchCopy") }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn color="alartGentle" dark v-on="on">
            <v-icon>mdi-translate</v-icon>
            <span v-if="$vuetify.breakpoint.smAndUp">{{ $t("language") }}</span>
            <span v-else>{{ $t("lang") }}</span>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="changeLanguage('en')">
            <v-list-item-title>English</v-list-item-title>
          </v-list-item>
          <v-list-item @click="changeLanguage('ja')">
            <v-list-item-title>日本語</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-app-bar>
    <v-navigation-drawer fixed clipped app v-model="drawer" width="260" touchless>
      <v-list>
        <v-list-item href="https://company.foodealist.com/">
          <v-list-item-content>
            <v-list-item-title>{{ $t("company") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{name: 'privacyPolicy', params:{  locale: $i18n.locale}}">
          <v-list-item-content>
            <v-list-item-title>{{ $t("privacyPolicy") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item :to="{name: 'termsOfUse', params:{  locale: $i18n.locale}}">
          <v-list-item-content>
            <v-list-item-title>{{ $t("termsOfUse") }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <v-content>
      <router-view />
    </v-content>
    <v-bottom-navigation app background-color="secondary" color="black">
      <v-btn :to="{name: 'home', params:{ locale: $i18n.locale}}">
        <span class="font-weight-bold">{{ $t("home") }}</span>
        <v-icon>mdi-home</v-icon>
      </v-btn>
      <v-btn :to="{name: 'favorites', params:{ locale: $i18n.locale}}">
        <span class="font-weight-bold">{{ $t("favorites") }}</span>
        <v-icon>mdi-heart</v-icon>
      </v-btn>
      <v-btn :to="{name: 'purpleSpoon', params:{ locale: $i18n.locale}}">
        <span class="font-weight-bold">{{ $t("purpleSpoon") }}</span>
        <v-icon>mdi-map-marker</v-icon>
      </v-btn>      
    </v-bottom-navigation>
  </v-app>
</template>

<i18n>
{
  "en": {
    "catchCopy": "Media for Diverse Food Culture",
    "language": "English",
    "lang": "En",
    "search": "Search",
    "purpleSpoon": "Purple Spoon",
    "favorites": "Favorites",
    "home": "Home",
    "company": "Company Infomation",
    "privacyPolicy": "Privacy Policy",
    "termsOfUse": "Terms Of Use"
  },
  "ja": {
    "catchCopy": "多様な食を発信するフードスタイルメディア「フーディアリスト」",
    "language": "日本語",
    "lang": "日",
    "search": "検索",
    "purpleSpoon": "Purple Spoon",
    "favorites": "お気に入り",
    "home": "ホーム",
    "company": "運営会社",
    "privacyPolicy": "プライバシーポリシー",
    "termsOfUse": "利用規約"
  }
}
</i18n>

<script>
import { mapState } from "vuex";

import { EventBus } from "@/event.js";
import Loading from "@/components/Loading.vue";
import CookieConsent from "@/components/CookieConsent.vue";
import SnackBar from "@/components/SnackBar.vue";

export default {
  name: "App",
  components: {
    Loading,
    CookieConsent,
    SnackBar
  },
  data: () => ({
    drawer: false,
    locale: ""
  }),
  metaInfo: {
    titleTemplate: "Foodealist|多様な食を発信するフードスタイルメディア「フーディアリスト」 - %s"
  },
  mounted() {
    if (this.trackingAllowed) {
      this.$gtag.optIn();
    } else {
      this.$gtag.optOut();
    }
  },
  computed: mapState(["trackingAllowed"]),
  methods: {
    changeLanguage(locale) {
      if (locale !== this.$root.$i18n.locale) {
        this.$root.$i18n.locale = locale;
        document.documentElement.lang = locale;
        const params = Object.assign({}, this.$route.params);
        params.locale = locale;
        this.$router.push({
          name: this.$route.name,
          params
        });
      }
    },
    reload(to, from) {
      const validLocales = ["ja", "en"];
      if (!validLocales.includes(to.params.locale)) {
        this.$router.push({ name: "home", params: { locale: "en" } });
      } else if (
        typeof from.params.locale !== "undefined" &&
        typeof to.params.locale !== "undefined"
      ) {
        // if locale changed, reload page
        if (from.params.locale !== to.params.locale) {
          this.$router.go();
        }
      }
    }
  },
  watch: {
    $route: "reload"
  }
};
</script>

<style>
html,
body {
  margin: 0px auto;
  padding: 0px;
}
</style>